<crm-multi-select
  [filtersUiVersion]="filtersUiVersion"
  #multiSelectComponent
  [options]="entities"
  optionLabel="name"
  filterBy="name"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [selectedItems]="_selectedEntities"
  (selectedItemsChange)="onSelect($event)"
  (panelShow)="onShowPanel()"
  (panelHide)="onPanelHide($event)"
  (openedChange)="openedChange.emit($event)"
  (onFilter)="search($event.filter)"
  [label]="isFloatLabel ? selectLabel : ''"
  [appendTo]="appendTo"
  [scrollHeight]="scrollHeight"
  [disabled]="disabled"
  [showClear]="showClear"
  [display]="display"
  [sort]="customSearch ? sort : ''"
  [moveDown]="moveDown"
  [placeholder]="placeholder"
  [loading]="loading || selectionLoading">
  <ng-template #footerTemplate>
    <crm-spinner
      *ngIf="paginationLoading"
      top=""
      text=""
      [height]="35"
      [width]="35"
      bottom=""></crm-spinner>
  </ng-template>
</crm-multi-select>
